import './assets/main.css'
import './assets/Menu.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from "./router"; // Import router
import { createHead } from '@vueuse/head';
import { CPRRouterPatch } from 'shared-vue'
import { createPinia } from "pinia";
import './assets/bootstrap.scss'
import * as Sentry from '@sentry/vue';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(reg => {
      console.log('Service worker registered', reg);
    })
    .catch(err => {
      console.warn('Service worker registration failed', err);
    });
}

const app = createApp(App);


const isLocal = location.hostname === 'localhost' || location.hostname.startsWith('192.');
const traceSampleRate = isLocal ? 0.0 : 0.01; // 0 for local, 1% elsewhere
if (import.meta.env.MODE !== "development") {
  Sentry.init({
    app,
    dsn: 'https://4f086851af585c0d47d21d37c9e0766b@o4509215259295744.ingest.de.sentry.io/4509215835947088',
    environment: import.meta.env.MODE,
    integrations: [
      //new Replay(), 
    ],
    tracesSampleRate: traceSampleRate, // 1% of requests tracked
    replaysSessionSampleRate: 0, // 0 = disable replays unless you want full recordings
    replaysOnErrorSampleRate: 1.0, // captures replay if an error happens
    sendDefaultPii: true
  });
}
const head = createHead();
const pinia = createPinia();

pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router); // Tell Vue to use Vue Router
app.use(CPRRouterPatch(router));
app.use(head);
app.mount("#app");
